import styled from 'styled-components';

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;


export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const TemplateList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: stretch;
    padding: 0 50px;
`;

export const TemplateItem = styled.div`
    width: calc(33% - 14px);
    margin: 0 20px 20px 0;
    border: 1px solid #888;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    cursor: pointer;
    transition: all .3s ease 0s;

    &:nth-child(3n) {
        margin-right: 0;
    }

    :hover {
        border-color: #f92;
    }

    &.selected {
        border-color: #f92;
    }
`;

export const TemplateAdd = styled.div`
    width: calc(16.666% - 14px);
    border: 1px solid #888;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s ease 0s;
    font-size: 14px;
    text-transform: uppercase;
    flex-direction: column;
    min-height: 75px;
    margin-bottom: 20px;
    color: #fff;

    :hover {
        border-color: #f92;
        color: #f92;
    }
`;

export const TemplateItemInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const TemplateItemIcons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
`;

export const TemplateItemName = styled.div`
    color: #fff;
    transition: all .3s ease 0s;

    ${TemplateItem}:hover & {
        color: #f92;
    }
    
    ${TemplateItem}.selected & {
        color: #f92;
    }
`;

export const TemplateItemCreatedBy = styled.div`
    color: #888;
    margin-top: 5px;
    font-size: 14px;
    translate: color .3s ease 0s;
`;

const BaseIcon = styled.div`
    width: 25px;
    height: 25px;
    position: relative;
    
    &:before {
        transition: all .4s ease 0s;
        color: #777;
        font-size: 24px;
        content: '\\F1398';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${TemplateItem}.selected &:before {
        color: #000;
    }
`;

export const TemplateIconOwner = styled(BaseIcon)`
    &:before {
        color: #f93;
        content: '\\F01A5';
    }
`;

export const TemplateIconEditor = styled(BaseIcon)`
    &:before {
        color: #090;
        content: '\\F06BC';
    }
`;

export const TemplateIconStaff = styled(BaseIcon)`
    &:before {
        color: #fc0;
        content: '\\F047A';
    }
`;

export const TemplateIconAdd = styled(BaseIcon)`
    &:before {
        color: #fff;
        content: '\\F0415';
    }
    ${TemplateAdd}:hover &:before {
        color: #f93;
    }
`;


